import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FilterEngineV2Component, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { GatewaysShellComponent } from './containers/gateways-shell/gateways-shell.component';
import { GatewaysRoutingModule } from './gateways-routing.module';
import { GatewaysEffects } from './state/effects/gateways.effects';
import * as fromGateways from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslatePipe,
    ToolbarV2Module,
    MasterViewEngineModule,
    GatewaysRoutingModule,
    StoreModule.forFeature(fromGateways.featureKey, fromGateways.reducers),
    EffectsModule.forFeature([GatewaysEffects]),
    FilterEngineV2Component
  ],
  declarations: [GatewaysShellComponent]
})
export class GatewaysModule {}
